import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'filterByDistricts'
})
export class FilterByDistrictsPipe implements PipeTransform {

	transform(items: Array<any>, districts: any = []): Array<any> {
		console.log('hereeeeeeee');
		if (!items) {
			return [];
		}
		if (!districts.length) {
			return items;
		}
		return items.filter(item => {
			return districts.some(district => {
				if (item.hasOwnProperty('address')) {
					if (item.address.hasOwnProperty('district')) {
						console.log(2);
						if (item.address.district.hasOwnProperty('name')) {
							console.log('asdasdasd', item.address.district.name === district);
							return item.address.district.name === district;

						} else {
							return false;
						}
					}
				} else {
					return false;
				}
			});
		});
	}
}
